export enum TimeOfDay {
  AM = 'AM',
  PM = 'PM'
}
